// config.js
export default {
  base_url:'https://nefccuapi.akkuratebank.com'
}
